export default "__VITE_ASSET__DY1KYY5m__"